import { useState } from "react";
import API from "../config/api.js";

export default function AccountChangePassword() {
  const [passwords, setPasswords] = useState({ currentpassword: "", password: "", password2: "" });
  const [saving, setSaving]       = useState(false);
  const [alert, setAlert]         = useState(null);

  const handleSave = async (e) => {
    e.preventDefault();
    if (passwords.password !== passwords.password2) {
      setAlert({ type: "warning", msg: "Passwords do not match. Try again." });
      return;
    }
    setSaving(true);
    setAlert(null);
    try {
      const fd = new FormData();
      Object.entries(passwords).forEach(([k, v]) => fd.append(k, v));
      const res  = await fetch(`${API.account}?editPassword`, { method: "POST", credentials: "include", body: fd });
      const data = await res.json();
      if (data === true || data?.success) {
        setAlert({ type: "success", msg: "Password updated!" });
        setPasswords({ currentpassword: "", password: "", password2: "" });
      } else {
        setAlert({ type: "warning", msg: data?.error || "Error updating password." });
      }
    } catch (_) {
      setAlert({ type: "danger", msg: "Error updating password." });
    } finally {
      setSaving(false);
    }
  };

  const field = (key, label) => (
    <div className="col-md-4">
      <label className="text-dark mb-2 fw-700">{label} *</label>
      <input type="password" className="form-control form-control-lg"
        value={passwords[key]}
        onChange={(e) => setPasswords((p) => ({ ...p, [key]: e.target.value }))}
        required minLength={6} placeholder="•••••••••••••••" autoComplete="off" />
    </div>
  );

  return (
    <form onSubmit={handleSave}>
      <div className="border rounded-4 p-4">
        <div className="row mb-3">
          <div className="col-md-7">
            <h2 className="fs-6 fw-700">Change password</h2>
            <p className="text-muted">Confirm the old one, set a new one.</p>
          </div>
        </div>

        {alert && (
          <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
            {alert.msg}
            <button type="button" className="btn-close" onClick={() => setAlert(null)} />
          </div>
        )}

        <div className="row g-4">
          {field("currentpassword", "Current password")}
          {field("password",        "New password")}
          {field("password2",       "New password again")}
        </div>

        <div className="text-end mt-3">
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Updating..." : "Update Password"}
          </button>
        </div>
      </div>
    </form>
  );
}
